<template>
	<div class="layer-project" data-project-name="ezwel-renewal">
		<!-- Project Name -->
		<div class="layer-project-detail">
			<section class="project-visual">
				<div>
					<h1 class="project-tit">
						EZWEL <br class="lb-m" />Corporate <br />Site Renewal
					</h1>
					<a href="http://www.ezwel.com" class="link" target="_blank"
						>www.ezwel.com</a
					>
				</div>
			</section>
			<!-- Details [s] -->
			<section class="project-overview">
				<div class="inner-section">
					<h2 class="project-overview-tit">Overview</h2>
					<p class="project-overview-txt">
						복지 전문 기업 이지웰 법인 사이트로 직관적인 <br class="lb-m" />메뉴
						체계 개선, 디자인 개편 작업을 진행하였습니다.<br />
						이지웰의 사업 서비스를 소개하고 기업의 비전 및
						<br class="lb-m" />주가 정보, 복지 정보 등을 제공합니다.<br />
						주요 페이지에서 포인트 컬러와 픽토그램을 적절히
						<br class="lb-m" />사용하여 내용의 강약 조절 및
						<br class="lb-t" />기업의 아이덴티티를 강화하였습니다.
						<br />사용자가 PC와 모바일에서 동일한 경험을 할 수 있도록
						최적화하였습니다.
					</p>
					<div class="project-overview-diagram">
						<ul class="diagram01">
							<li>
								<span>Corporate<br />Identity</span>
							</li>
							<li>
								<span>Improved<br />UI/UX Design</span>
							</li>
							<li>
								<span>Design<br />Trend</span>
							</li>
						</ul>
						<ul class="diagram02">
							<li>
								<span>EZWEL<br />CORPORATE<br />SITE</span>
							</li>
						</ul>
					</div>
				</div>
			</section>
			<section class="section section01 full">
				<div class="inner-section">
					<div class="size-info"><span>1920 x 1080px</span></div>
					<div class="content content01">
						<div class="content-tit">EZWEL<br />Welfare<br />Solution</div>
						<div class="detail-img">
							<div>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ezwel-renewal/sec1-img01@m.png"
									data-break="m-tw"
								/>
							</div>
							<div>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ezwel-renewal/sec1-img02@m.png"
									data-break="m-tw"
								/>
							</div>
						</div>
					</div>
					<div class="content content02">
						<div class="content-tit">
							<strong>Sub Page<br />Design</strong>
						</div>
						<div class="ezwel-swiper">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/ezwel-renewal/sec1-slide01@m.jpg"
										data-break="m-tw"
									/>
									<strong class="slide-tit">BUSINESS</strong>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/ezwel-renewal/sec1-slide02@m.jpg"
										data-break="m-tw"
									/>
									<strong class="slide-tit">SUPPORT</strong>
								</div>
								<div class="swiper-slide">
									<img
										src=""
										alt=""
										data-src="/static/img/project-detail/ezwel-renewal/sec1-slide03@m.jpg"
										data-break="m-tw"
									/>
									<strong class="slide-tit">COMPANY</strong>
								</div>
							</div>
							<div class="ezwel-pagination swiper-pagination"></div>
						</div>
					</div>
				</div>
			</section>
			<section class="section section02 full">
				<div class="inner-section">
					<div class="size-info"><span>360px</span></div>
					<div class="content content01">
						<div class="content-tit">Mobile<br />Main<br />Design</div>
						<div>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ezwel-renewal/sec2-img01@m.png"
								data-break="m-tw"
							/>
						</div>
					</div>
					<div class="content content02">
						<div>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ezwel-renewal/sec2-img02@m.png"
								data-break="m-tw"
							/>
						</div>
					</div>
					<div class="content content03">
						<div>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ezwel-renewal/sec2-img03@m.png"
							/>
						</div>
					</div>
				</div>
			</section>
			<section class="section section03">
				<div class="inner-section">
					<div class="detail-cont content01">
						<div>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ezwel-renewal/sec3-icon-main@m.png"
								data-break="m-tw"
							/>
						</div>
						<div>
							<img
								src=""
								alt=""
								data-src="/static/img/project-detail/ezwel-renewal/sec3-icons@m.png"
								data-break="m-tw"
							/>
						</div>
						<div>
							<div>
								<img
									src=""
									alt=""
									data-src="/static/img/project-detail/ezwel-renewal/sec3-font@m.png"
									data-break="m-tw"
								/>
							</div>
							<ul>
								<li data-color="#2f4553">#2f4553</li>
								<li data-color="#222222">#222222</li>
								<li data-color="#005ec5">#005ec5</li>
								<li data-color="#00ccff">#00ccff</li>
								<li data-color="#0196ff">#0196ff</li>
								<li data-color="#ff4c2f">#ff4c2f</li>
								<li data-color="#f6f6f6">#f6f6f6</li>
								<li data-color="#aaaaaa">#aaaaaa</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
			<!-- Details [e] -->
			<section class="project-client">
				<strong class="a11y-hidden">EZWEL</strong>
			</section>
			<!-- Page Contents -->
		</div>

		<app-pjmove></app-pjmove>
	</div>
</template>

<script>
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
import pjMove from "../components/pjMove.vue";
import projectCommon from "../assets/js/projectCommon.js";

export default {
	components: {
		"app-pjmove": pjMove,
	},
	mixins: [projectCommon],
	mounted: function () {
		this.projectInit();

		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var ezwelSwiper;

		if (winW < 712) {
			mobileSwiper();
		} else {
			isSlider = true;
		}

		var mobileSwiper = function () {
			if (isSlider) {
				isSlider = false;
				ezwelSwiper = new Swiper(".ezwel-swiper", {
					slidesPerView: 1,
					spaceBetween: 25,
					pagination: {
						el: ".ezwel-pagination",
						clickable: true,
					},
				});
			}
		};

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					mobileSwiper();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					ezwelSwiper.destroy();
					$(".ezwel-pagination").children().remove();
				}
			}
		});
	},
};
</script>
<!-- css 추가 -->
<style>
@import "../../static/css/swiper.min.css"; /* if use swiper.min.js */
@import "../../static/css/projects.css"; /* Common Project Detail Page */
</style>
<style scoped>
/* temp */
.layer-project-detail > section.full {
	padding: 0;
}
.layer-project-detail > section:not(.project-visual) img {
	width: 100%;
}
.project-visual > div {
	padding-top: 10px;
}
.project-tit .nowrap {
	display: block;
}
.section {
	position: relative;
}
.section .inner-section {
	position: relative;
}
.section .cont-desc {
	word-break: keep-all;
}
.section.full .con-tit-area {
	max-width: 1280px;
	margin: 0 auto;
}
.section .size-info {
	color: #fff;
}
.section .content-tit {
	font-weight: 800;
}
.section .content {
	position: relative;
}
.section .content-tit::after {
	content: "";
	display: inline-block;
	margin-left: 8px;
	border-radius: 50%;
	background-color: #00cbff;
}
@media screen and (max-width: 711px) {
	.section.full .max-limit {
		padding: 0 15px;
	}
	.section .size-info {
		padding-left: 15px;
		padding-top: 30px;
		font-size: 12px;
	}
	.lb-m {
		display: block;
	}
	.lb-t {
		display: none;
	}
	.lb-w {
		display: none;
	}
}
@media screen and (min-width: 712px) {
	.section.full .max-limit {
		padding: 0 40px;
	}
	.section .size-info {
		padding-left: 34px;
		padding-top: 40px;
		font-size: 12px;
	}
	.lb-m {
		display: none;
	}
	.lb-t {
		display: block;
	}
	.lb-w {
		display: none;
	}
}
@media screen and (min-width: 1280px) {
	.section.full {
		max-width: 1920px;
	}
	.section.full .max-limit {
		max-width: 1280px;
		margin: 0 auto;
		padding-left: 20px;
		padding-right: 20px;
	}
	.section .size-info {
		padding-left: 80px;
		padding-top: 90px;
		font-size: 20px;
	}
	.lb-m {
		display: none;
	}
	.lb-t {
		display: none;
	}
	.lb-w {
		display: block;
	}
}

/* Project Visual */
.project-client {
	background: url(/static/img/project-detail/ezwel-renewal/ci.png) 50%/147px
		46px no-repeat;
}
@media screen and (max-width: 711px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ezwel-renewal/bg-overview@m.jpg);
	}
}
@media screen and (min-width: 712px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ezwel-renewal/bg-overview@t.jpg);
	}
	.project-client {
		background-size: 208px 52px;
	}
}
@media screen and (min-width: 1280px) {
	.project-visual {
		background-image: url(/static/img/project-detail/ezwel-renewal/bg-overview@w.jpg);
	}
	.project-client {
		background-size: 415px 111px;
	}
}

/* Project Overview */
.project-overview {
	background-color: #e9f1f3;
}
.project-overview-diagram {
	margin-top: 25px;
}
.project-overview-diagram:after {
	content: "";
	display: block;
	clear: both;
}
.diagram01 {
	position: relative;
}
.diagram01 li,
.diagram02 li {
	position: relative;
	display: flex;
	justify-content: center;
	align-items: center;
	border-radius: 50%;
	text-align: center;
}
.diagram01 li {
	position: absolute;
	background-color: #fff;
}
.diagram02 li {
	background-color: #005ec5;
	color: #fff;
}
.diagram02 li:before {
	content: "";
	position: absolute;
	background-color: #005ec5;
}
@media screen and (max-width: 711px) {
	.diagram01 {
		height: 252px;
	}
	.diagram01 li,
	.diagram02 li {
		width: 132px;
		height: 132px;
	}
	.diagram01 li {
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
	}
	.diagram01 li:nth-child(1) {
		margin-left: -64px;
		margin-top: -54px;
	}
	.diagram01 li:nth-child(2) {
		margin-left: 64px;
		margin-top: -54px;
	}
	.diagram01 li:nth-child(3) {
		margin-top: 54px;
	}
	.diagram02 li {
		margin: 31px auto 0 auto;
	}
	.diagram02 li:before {
		top: -57px;
		left: 50%;
		width: 1px;
		height: 42px;
	}
}
@media screen and (min-width: 712px) {
	.project-overview-diagram {
		width: 614px;
		margin: 40px auto 0 auto;
	}
	.project-overview-diagram:after {
		content: "";
		display: block;
		clear: both;
	}
	.diagram01,
	.diagram02 {
		float: left;
	}
	.diagram01 {
		width: 400px;
		height: 138px;
	}
	.diagram01 li {
		font-size: 1.3rem;
		line-height: 34px;
	}
	.diagram01 li,
	.diagram02 li {
		width: 132px;
		height: 132px;
		font-size: 1.5rem;
		line-height: 18px;
	}
	.diagram01 li:nth-child(2) {
		margin-left: 130px;
	}
	.diagram01 li:nth-child(3) {
		margin-left: 260px;
	}
	.diagram02 {
		margin-left: 75px;
	}
	.diagram02 li:before {
		top: 50%;
		left: -74px;
		width: 66px;
		height: 1px;
	}
}
@media screen and (min-width: 1280px) {
	.project-overview {
		padding: 65px 0;
	}
	.project-overview-diagram {
		width: 1179px;
	}
	.project-overview-diagram:after {
		content: "";
		display: block;
		clear: both;
	}
	.diagram01 {
		float: left;
	}
	.diagram01 li {
		font-size: 2rem;
		line-height: 26px;
		border: 2px solid #fff;
	}
	.diagram01 li,
	.diagram02 li {
		width: 246px;
		height: 246px;
	}
	.diagram01 {
		width: 710px;
		height: 246px;
	}
	.diagram01 li:nth-child(2) {
		margin-left: 232px;
	}
	.diagram01 li:nth-child(3) {
		margin-left: 464px;
	}
	.diagram02 {
		float: right;
		font-size: 2.4rem;
		line-height: 28px;
	}
	.diagram02 li:before {
		left: -193px;
		width: 162px;
		height: 2px;
	}
}
/* section01 */
.section01 .content01 .detail-img div:nth-child(2)::before {
	position: absolute;
	left: 0;
	bottom: 0;
	content: "";
	display: block;
	width: 100%;
	background-color: #e9f1f3;
}
.section01::before {
	position: absolute;
	top: 0;
	left: 0;
	display: block;
	content: "";
	background-color: #00cbff;
}
.section01 .content01 .content-tit {
	font-size: 27px;
	line-height: 35px;
}
.section01 .content01 .content-tit::after {
	width: 10px;
	height: 10px;
}
.section01 .content01 .detail-img div:nth-child(2) img {
	position: relative;
}
.section01 .content02 {
	background-color: #e9f1f3;
}
.section01 .content02 .content-tit {
	font-size: 19px;
	line-height: 23px;
}
.section01 .content02 .content-tit::before {
	position: absolute;
	content: "";
	border-radius: 50%;
	background-color: #fff;
}
.section01 .content02 .content-tit::after {
	width: 8px;
	height: 8px;
	background-color: #00cbff;
}
.section01 .content02 .content-tit strong {
	position: relative;
}
.section01 .content02 .ezwel-swiper {
	margin: 0 auto;
}
.section01 .content02 .swiper-slide strong {
	display: block;
}
.section01 .content02 .swiper-slide strong::before {
	content: "";
	display: inline-block;
	background-color: #00c7fa;
	vertical-align: middle;
}
@media screen and (max-width: 711px) {
	.section01::before {
		min-width: 111px;
		width: 34.6875vw;
		min-height: 482px;
		height: 150.625vw;
	}
	.section01 .size-info {
		color: #fff;
	}
	.section01 .content01 .content-tit {
		padding-top: 20px;
		padding-left: 85px;
	}
	.section01 .content01 .detail-img {
		margin-top: 10px;
	}
	.section01 .content01 .detail-img div:nth-child(1) {
		padding-left: 40px;
	}
	.section01 .content01 .detail-img div:nth-child(2)::before {
		height: 95px;
	}
	.section01 .content02 {
		padding-top: 40px;
	}
	.section01 .content02 .content-tit {
		position: relative;
		width: 62.1875vw;
		margin: 0 auto;
	}
	.section01 .content02 .content-tit::before {
		top: -47px;
		left: -77px;
		width: 130px;
		height: 130px;
	}
	.section01 .content02 .ezwel-swiper {
		margin-top: 15px;
		width: 62.1875vw;
	}
	.section01 .content02 .swiper-wrapper {
		padding-bottom: 70px;
	}
	.section01 .content02 .swiper-slide img {
		box-shadow: 15px 13px 36px 0px rgba(0, 0, 0, 0.19);
	}
	.section01 .content02 .swiper-slide strong {
		margin-top: 12px;
		font-size: 12px;
	}
	.section01 .content02 .swiper-slide strong::before {
		width: 11px;
		height: 2px;
		margin-right: 10px;
	}
	.section01 .content02 .swiper-pagination {
		padding-top: 30px;
		padding-bottom: 40px;
	}
}
@media screen and (min-width: 712px) {
	.section01::before {
		width: 20.786vw;
		height: 70.154vw;
	}
	.section01 .size-info {
		padding-top: 40px;
		padding-left: 33px;
		font-size: 12px;
		line-height: 38px;
	}
	.section01 .content01 .content-tit {
		position: absolute;
		top: 75px;
		left: 18.9606vw;
		width: 30.77vw;
	}
	.section01 .content01 .content-tit::before {
		position: absolute;
		top: 50%;
		right: 0;
		content: "";
		display: block;
		min-width: 67px;
		width: 9.41vw;
		height: 1px;
		background-color: #ccc;
	}
	.section01 .content01 .detail-img div:nth-child(1) {
		position: relative;
		left: calc(50% - 10px);
		width: 58.6376vw;
	}
	.section01 .content01 .detail-img div:nth-child(2) {
		width: 93.39vw;
		margin-top: 20px;
	}
	.section01 .content01 .detail-img div:nth-child(2)::before {
		height: 155px;
	}
	.section01 .content02 {
		padding-left: 40px;
		padding-top: 60px;
		padding-bottom: 60px;
	}
	.section01 .content02 .content-tit::before {
		top: 10px;
		left: 82px;
		width: 165px;
		height: 165px;
	}
	.section01 .content02 .content-tit::after {
		position: relative;
		z-index: 1;
	}
	.section01 .content02::after {
		content: "";
		display: block;
		clear: both;
	}
	.section01 .content02 > div {
		float: left;
	}
	.section01 .content02 .ezwel-swiper {
		margin-left: 50px;
		margin-right: -200px;
	}
	.section01 .content02 .ezwel-swiper .swiper-wrapper {
		display: flex;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide {
		width: 27.949vw;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide + .swiper-slide {
		margin-left: 15px;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide img {
		box-shadow: 14px 13px 36px 0px rgba(0, 0, 0, 0.19);
	}
	.section01 .content02 .ezwel-swiper .swiper-slide strong {
		margin-top: 12px;
		font-size: 12px;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide strong::before {
		width: 11px;
		height: 2px;
		margin-right: 5px;
	}
}
@media screen and (min-width: 1280px) {
	.section01::before {
		width: 296px;
		height: 999px;
	}
	.section01 .size-info {
		padding-top: 80px;
		padding-left: 80px;
		font-size: 20px;
	}
	.section01 .content01 .content-tit {
		top: 238px;
		left: 274px;
		width: 585px;
		font-size: 60px;
		line-height: 76px;
	}
	.section01 .content01 .content-tit::before {
		width: 251px;
	}
	.section01 .content01 .content-tit::after {
		width: 20px;
		height: 20px;
		margin-left: 16px;
	}
	.section01 .content01 .detail-img div:nth-child(1) {
		left: calc(50% - 120px);
		width: 1096px;
	}
	.section01 .content01 .detail-img div:nth-child(2) {
		width: 1634px;
		margin-top: 100px;
	}
	.section01 .content01 .detail-img div:nth-child(2)::before {
		height: 375px;
	}
	.section01 .content02 {
		padding: 140px 0 60px 240px;
		overflow: hidden;
	}
	.section01 .content02 .content-tit {
		position: relative;
		font-size: 40px;
		line-height: 50px;
	}
	.section01 .content02 .content-tit::before {
		top: -138px;
		left: 85px;
		width: 414px;
		height: 414px;
	}
	.section01 .content02 .content-tit::after {
		position: relative;
		z-index: 1;
		width: 20px;
		height: 20px;
	}
	.section01 .content02::after {
		content: "";
		display: block;
		clear: both;
	}
	.section01 .content02 > div {
		float: left;
	}
	.section01 .content02 .ezwel-swiper {
		position: relative;
		top: -100px;
		right: -300px;
		width: 1900px;
		margin-right: 0;
	}
	.section01 .content02 .ezwel-swiper .swiper-wrapper {
		display: flex;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide {
		width: 498px;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide + .swiper-slide {
		margin-left: 35px;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide img {
		box-shadow: 29px 26px 73px 0px rgba(0, 0, 0, 0.19);
	}
	.section01 .content02 .ezwel-swiper .swiper-slide strong {
		margin-top: 30px;
		font-size: 18px;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide strong::before {
		width: 22px;
		height: 3px;
		margin-right: 10px;
	}
}
@media (min-width: 1280px) and (max-width: 1785px) {
	.section01 .content02 {
		padding: 140px 0 60px 80px;
	}
	.section01 .content02 .ezwel-swiper {
		margin-left: 0;
	}
	.section01 .content02 .ezwel-swiper .swiper-slide {
		width: 27.949vw;
	}
}
/* section02 */
.section02::before {
	position: absolute;
	left: 0;
	display: block;
	content: "";
	width: 100%;
}
.section02 .content img {
	position: relative;
}
.section02 .content-tit {
	font-size: 27px;
	line-height: 35px;
	color: #fff;
}
.section02 .content-tit + div::before {
	position: absolute;
	content: "";
	display: block;
	background-color: #fff;
	border-radius: 50%;
}
.section02 .content-tit {
	position: absolute;
	width: 50%;
	left: 50%;
}
.section02 .content-tit::after {
	width: 9px;
	height: 9px;
	background-color: #fff;
}
.section02 .content-tit strong {
	display: block;
}
.section02 .content-tit + div {
	position: relative;
}
@media screen and (max-width: 711px) {
	.section02 {
		background-color: #00cbff;
	}
	.section02::before {
		bottom: 0;
		height: 211.46875vw;
		background-color: #fff;
	}
	.section02 .content01 {
		margin-top: 15px;
		padding: 0 15px;
	}
	.section02 .content-tit {
		top: 50%;
		padding-left: 11.875vw;
	}
	.section02 .content-tit strong {
		margin-top: 260px;
	}
	.section02 .content-tit + div {
		padding: 0 35px;
	}
	.section02 .content-tit + div::before {
		top: 28px;
		left: 0;
		width: 57.0312vw;
		height: 57.0312vw;
	}
	.section02 .content-tit + div img {
		width: 58.28125vw;
	}
	.section02 .content02 {
		margin-top: 20px;
	}
}
@media screen and (min-width: 712px) {
	.section02 {
		background-color: #fff;
	}
	.section02::before {
		top: 0;
		height: 60.422vw;
		background-color: #00cbff;
	}
	.section02 .inner-section {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	.section02 .size-info {
		width: 100%;
	}
	.section02 .content {
		width: 50%;
	}
	.section02 .content-tit {
		top: 173px;
		left: 50%;
		z-index: 1;
		padding-left: 28px;
	}
	.section02 .content-tit + div {
		margin-left: 70px;
		padding: 0 47px;
	}
	.section02 .content-tit + div::before {
		top: 28px;
		left: calc(50% - 20.2485vw);
		width: 33.4971vw;
		height: 33.4971vw;
	}
	.section02 .content01 {
		position: initial;
		margin-top: 22px;
	}
	.section02 .content02 {
		padding-top: 35.0505vw;
		padding-right: 22px;
	}
	.section02 .content03 {
		width: 100%;
		margin-top: 40px;
	}
}
@media screen and (min-width: 1280px) {
	.section02::before {
		top: 0;
		height: 954px;
	}
	.section02 .content {
		width: 50%;
	}
	.section02 .content-tit {
		top: 365px;
		left: 50%;
		z-index: 1;
		padding-left: 65px;
		font-size: 60px;
		line-height: 76px;
	}
	.section02 .content-tit::after {
		width: 20px;
		height: 20px;
	}
	.section02 .content-tit + div {
		left: calc(50% - 120px);
		margin-left: 0;
		padding: 0;
		width: 530px;
		text-align: center;
	}
	.section02 .content-tit + div img {
		width: 474px;
	}
	.section02 .content-tit + div::before {
		top: 68px;
		left: calc(50% - 330px);
		width: 530px;
		height: 530px;
	}
	.section02 .content01 {
		position: initial;
		margin-top: 50px;
		padding-left: 80px;
	}
	.section02 .content02 {
		padding-top: 573px;
		width: 50%;
	}
	.section02 .content02 div {
		width: 722px;
	}
	.section02 .content03 {
		width: 100%;
		margin-top: 108px;
	}
}
@media (min-width: 713px) and (max-width: 1690px) {
	.section02 .content-tit + div {
		width: 70%;
	}
}
/* section03 */
.section03 {
	background-color: #f0f7fa;
}
.section03 .content01 ul {
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	width: 100%;
}
.section03 .content01 li {
	width: 50%;
	height: 25px;
	color: rgba(255, 255, 255, 0.7);
}
.section03 .content01 li:nth-child(-n + 4) {
	height: 50px;
	padding-top: 20px;
	line-height: 1;
}
.section03 .content01 li[data-color="#2f4553"] {
	background-color: #2f4553;
}
.section03 .content01 li[data-color="#222222"] {
	background-color: #222;
}
.section03 .content01 li[data-color="#005ec5"] {
	background-color: #005ec5;
}
.section03 .content01 li[data-color="#00ccff"] {
	background-color: #00ccff;
}
.section03 .content01 li[data-color="#0196ff"] {
	background-color: #0196ff;
}
.section03 .content01 li[data-color="#ff4c2f"] {
	background-color: #ff4c2f;
}
.section03 .content01 li[data-color="#f6f6f6"] {
	background-color: #f6f6f6;
	border: 1px solid #ddd;
	color: #222;
}
.section03 .content01 li[data-color="#aaaaaa"] {
	background-color: #aaaaaa;
}
@media screen and (max-width: 711px) {
	.section03 .content01 > div:nth-child(1) {
		position: relative;
		left: calc(50% - 14.375vw);
		width: 59.53125vw;
	}
	.section03 .content01 > div:nth-child(2) {
		margin-top: 25px;
	}
	.section03 .content01 > div:nth-child(3) {
		margin-top: 40px;
	}
	.section03 .content01 ul {
		margin-top: 40px;
	}
	.section03 .content01 ul li {
		padding-left: 10px;
		font-size: 12px;
		line-height: 25px;
	}
}
@media screen and (min-width: 712px) {
	.section03 {
		padding-bottom: 60px;
	}
	.section03 .content01 > div:nth-child(1) {
		position: relative;
		left: calc(50% - 52px);
		width: 208px;
	}
	.section03 .content01 > div:nth-child(2) {
		margin-top: 37px;
	}
	.section03 .content01 > div:nth-child(3) {
		display: flex;
		justify-content: space-between;
		margin-top: 50px;
	}
	.section03 .content01 > div:nth-child(3) > * {
		width: 50%;
	}
	.section03 .content01 > div:nth-child(3) div {
		padding-right: 30px;
	}
	.section03 .content01 > div:nth-child(3) ul {
		padding-left: 50px;
	}
	.section03 .content01 > div:nth-child(3) li {
		padding-left: 10px;
	}
}
@media screen and (min-width: 1280px) {
	.section03 {
		padding-bottom: 140px;
	}
	.section03 .inner-section {
		padding: 0;
	}
	.section03 .content01 li {
		width: 264px;
		height: 50px;
		line-height: 50px;
	}
	.section03 .content01 li:nth-child(-n + 4) {
		height: 103px;
		padding-top: 70px;
	}
	.section03 .content01 > div:nth-child(1) {
		position: relative;
		left: calc(50% - 111px);
		width: 416px;
	}
	.section03 .content01 > div:nth-child(2) {
		margin-top: 72px;
	}
	.section03 .content01 > div:nth-child(3) {
		margin-top: 100px;
	}
	.section03 .content01 > div:nth-child(3) div {
		width: 574px;
		padding: 0;
	}
	.section03 .content01 > div:nth-child(3) ul {
		width: 528px;
		justify-content: flex-end;
		padding: 0;
	}
	.section03 .content01 > div:nth-child(3) li {
		padding-left: 20px;
	}
}
</style>


// WEBPACK FOOTER //
// src/projects/ezwel-renewal.vue